import React, {memo} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

/* Config */
import appConfig from '../../../../../appConfig'

/* Styles */
import s from './tech-specs-table.scss'

const TechSpecsTable = memo(({techSpecs, className}) => {
  return (
    <div className={cx(s.productFeatures)}>
      {
        techSpecs?.map((item, index) => {
          return (
            <div className={cx(s.productFeature, className)} key={index}>
              <div className={s.name}>{item?.name}</div>
              <div className={s.property}>
                {
                  item?.propertyUrl ?
                    <a className={s.link} title={item?.property} href={`${appConfig.baseUrl}${item?.propertyUrl}`}>
                      {item?.property}
                    </a> :
                    <span>{item?.property}</span>
                }
              </div>
            </div>
          );
        })}
    </div>
  );
});

TechSpecsTable.propTypes = {
  techSpecs: PropTypes.object,
  className: PropTypes.string
}

export default TechSpecsTable
